import React, { useState, useEffect } from "react";
import Datepicker from "../../fixedassetelements/datepicker/Datepicker";
import {
  AddregButton,
  FilterIcon,
  SyncButton,
  UploadButton,
} from "../../fixedassetelements/button/Button";

import SyncPopup from "../SyncButton/SyncButton";
import UploadExcelModal from "../common/UploadExcelModal/UploadExcelModal";
import CustomFilter from "../filterIcon/CustomFilter";
import AddSalesRegister from "../forms/AddSalesRegister/AddSalesRegister";
import UploadFile from "../forms/UploadFile/UploadFile";
import SalesUploadedFiles from "../forms/UploadedSalesFiles/UploadedSalesFiles";
import ColumnMapping from "../forms/ColumnMappingForm/ColumnMapping";
import Submapping from "../forms/SubMapping/Submapping";
import ERPModal from "../common/ERPModal/ERPModal";
import SyncERPSuccess from "../SyncButton/SyncERPSuccess";
import AppendReplaceFile from "../common/AppendReplacePopup/AppendReplacePopup";
import {
  salesListing,
  getAllSalesErpData,
  putSaleFromERP,
} from "../../../Bookclosure/Services/ApiHandler";
import { GetSale } from "../../../WorkSpace/Components/ApiServices/apiHandler";
import ErrorPopup from "../../elements/ErrorPopup";
import SuccessPopup from "../../elements/SuccessPopup";
import DeletePopup from "../../elements/DeletePopup";

import styles from "./SalesregHeader.module.css";

const SalesregHeader = ({
  saleID,
  setSaleID,
  setShowDataState,
  tableType,
  setTableType,
  setShowTable,
  onFiltersApplied,
  showAddRegisterModal,
  setShowAddRegisterModal,
  appliedFilters: parentAppliedFilters,
}) => {
  const [asOnDate, setAsOnDate] = useState(
    new Date().toISOString().split("T")[0]
  );

  //const [showAddRegisterModal, setShowAddRegisterModal] = useState(false);
  const [showUploadExcelModal, setShowUploadExcelModal] = useState(false);
  const [showUploadFileModal, setShowUploadFileModal] = useState(false);
  const [showSalesUploadedFiles, setShowSalesUploadedFiles] = useState(false);
  const [showColumnMapping, setShowColumnMapping] = useState(false);
  const [showSubMapping, setShowSubMapping] = useState(false);
  const [showERPModal, setShowERPModal] = useState(false);
  const [showERPSuccessModal, setShowERPSuccessModal] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState(parentAppliedFilters || []);
  const [showPopup, setShowPopup] = useState(false);
  const [showAppendReplacePopup, setShowAppendReplacePopup] = useState(false);
  const [erpList, setErpList] = useState([]);
  const [selectedCardId, setSelectedCardId] = useState(null);
  const [isErpLoading, setIsErpLoading] = useState(false);
  const [errorPopup, setErrorPopup] = useState({ isOpen: false, title: "Error", message: "" });
  const [successPopup, setSuccessPopup] = useState({ isOpen: false, title: "Success", message: "" });
  const [deletePopup, setDeletePopup] = useState({ isOpen: false, title: "Are you sure?", message: "", fileIndex: null });

  useEffect(() => {
    if (parentAppliedFilters !== undefined) {
      setAppliedFilters(parentAppliedFilters);
    }
  }, [parentAppliedFilters]);

  const [uploadAction, setUploadAction] = useState(null);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadType, setUploadType] = useState(null);
  const [selectedFileIndex, setSelectedFileIndex] = useState(null);

  const [filterConfig, setFilterConfig] = useState([]);

  const formatDateInputValue = (value) => {
    if (!value) return "";
    const date = new Date(value);
    return !isNaN(date.getTime()) ? date.toISOString().split("T")[0] : "";
  };

  const resolveAsOnDateFromItems = (items, id) => {
    if (!Array.isArray(items)) return "";
    const match = items.find(
      (item) =>
        item &&
        (item._id === id ||
          item.id === id ||
          item.saleID === id ||
          item.purchaseID === id ||
          item.fixedAssetID === id)
    );
    if (match?.createdAt) {
      return formatDateInputValue(match.createdAt);
    }
    const firstCreatedAt = items.find((item) => item?.createdAt)?.createdAt;
    return formatDateInputValue(firstCreatedAt);
  };

  useEffect(() => {
    const fetchFilterConfig = async () => {
      try {
        if (!saleID) return;
        const savedTableType = sessionStorage.getItem(`tableType_${saleID}`);
        if (savedTableType) {
          setShowTable(true);
          setShowDataState(false);
          setTableType(savedTableType);
        }

        const response = await salesListing(saleID, {
          page: 1,
          pageSize: 30,
          filters: [],
        });

        if (response.data && response.data.filterAndAlignment) {
          setFilterConfig(response.data.filterAndAlignment);
        }
        if (response.data?.saleListing?.length > 0) {
          setShowTable(true);
          setShowDataState(false);
          if (!savedTableType) {
            setTableType("excel");
            sessionStorage.setItem(`tableType_${saleID}`, "excel");
          }
        } else if (!savedTableType) {
          try {
            const erpRes = await getAllSalesErpData(saleID);
            const list =
              erpRes.data?.ERPSaleList ||
              erpRes.data?.ERPSalesList ||
              erpRes.data?.data ||
              (Array.isArray(erpRes.data) ? erpRes.data : []);
            if (list && list.length > 0) {
              setShowTable(true);
              setShowDataState(false);
              setTableType("erp");
              sessionStorage.setItem(`tableType_${saleID}`, "erp");
            }
          } catch (e) {
            // ignore
          }
        }
      } catch (error) {
        console.error("Failed to fetch filter config:", error);
      }
    };

    const fetchAsOnDate = async () => {
      if (!saleID) {
        setAsOnDate(new Date().toISOString().split("T")[0]);
        return;
      }

      try {
        const response = await GetSale();
        const sales = response.data?.sales || response.data?.sale || response.data?.result || [];
        const dateFromSales = resolveAsOnDateFromItems(sales, saleID);
        if (dateFromSales) {
          setAsOnDate(dateFromSales);
          return;
        }

        const listingDate = formatDateInputValue(response.data?.saleListing?.[0]?.createdAt);
        setAsOnDate(listingDate || new Date().toISOString().split("T")[0]);
      } catch (error) {
        console.error("Failed to fetch sale createdAt:", error);
        setAsOnDate(new Date().toISOString().split("T")[0]);
      }
    };

    const initSale = async () => {
      if (!saleID) {
        try {
          const response = await GetSale();
          const sales =
            response.data?.sales ||
            response.data?.sale ||
            response.data?.result ||
            [];
          const saleArray = Array.isArray(sales) ? sales : [sales];
          if (saleArray.length > 0 && saleArray[0]) {
            const firstId =
              saleArray[0]._id || saleArray[0].id || saleArray[0].saleID;
            if (firstId && setSaleID) {
              setSaleID(firstId);
            }
          }
        } catch (error) {
          console.error("Failed to fetch initial sale:", error);
        }
      }
    };

    if (saleID) {
      fetchFilterConfig();
      fetchAsOnDate();
    } else {
      initSale();
    }
  }, [saleID, setSaleID]);

  const handleRemoveFile = (index) => {
    const file = uploadedFiles[index];
    const fileName =
      file?.displayName ||
      file?.name ||
      file?.fileName ||
      file?.originalname ||
      file?.rawFile?.name ||
      "this file";
    setDeletePopup({
      isOpen: true,
      title: "Are you sure?",
      message: `Once deleted, you will not be able to recover "${fileName}"!`,
      fileIndex: index,
    });
  };

  const handleConfirmDeleteFile = () => {
    if (deletePopup.fileIndex !== null) {
      setUploadedFiles((prev) =>
        prev.filter((_, i) => i !== deletePopup.fileIndex)
      );
    }
    setDeletePopup({
      isOpen: false,
      title: "Are you sure?",
      message: "",
      fileIndex: null,
    });
  };

  const handleAddFiles = () => {
    setShowSalesUploadedFiles(false);
    setShowUploadFileModal(true);
  };

  const handleApplyFilter = (filters) => {
    console.log("Filters received:", filters);
    setAppliedFilters(filters);
    setShowFilter(false);

    setShowTable(true);
    setShowDataState(false);

    if (onFiltersApplied) {
      onFiltersApplied(filters);
    }
  };

  const handleSelect = async (type) => {
    if (type === "uploadExcelModal") {
      setShowAddRegisterModal(false);
      setShowUploadExcelModal(true);
    } else if (type === "erp") {
      setShowAddRegisterModal(false);
      setShowERPModal(true);
      setIsErpLoading(true);
      try {
        let resolvedSaleID = saleID;
        if (!resolvedSaleID) {
          const response = await GetSale();
          const sales =
            response.data?.sales ||
            response.data?.sale ||
            response.data?.result ||
            [];
          const saleArray = Array.isArray(sales) ? sales : [sales];
          if (saleArray.length > 0 && saleArray[0]) {
            resolvedSaleID =
              saleArray[0]._id || saleArray[0].id || saleArray[0].saleID;
          }
        }
        const res = await getAllSalesErpData(resolvedSaleID);
        const list =
          res.data?.ERPSaleList ||
          res.data?.ERPSalesList ||
          res.data?.data ||
          (Array.isArray(res.data) ? res.data : []);
        if (list && list.length > 0) {
          setErpList(list);
        } else {
          setErpList([
            {
              _id: "5eed000000000000000000d3",
              name: "Sample Sales ERP Package",
              createdAt: new Date().toISOString(),
              userName: "Admin",
            },
          ]);
        }
      } catch (error) {
        console.error("Failed to fetch ERP sales:", error);
        setErpList([
          {
            _id: "5eed000000000000000000d3",
            name: "Sample Sales ERP Package",
            createdAt: new Date().toISOString(),
            userName: "Admin",
          },
        ]);
      } finally {
        setIsErpLoading(false);
      }
    }
  };

  const handleSelectUploadType = (type) => {
    setUploadType(type);
    setShowUploadExcelModal(false);
    setShowUploadFileModal(true);
  };

  const handleProceedToSalesUploadedFiles = (files) => {
    const normalized = (files || []).map((file) => {
      const computedName =
        file?.name ||
        file?.fileName ||
        file?.originalname ||
        file?.displayName ||
        file?.file?.name ||
        file?.file?.fileName ||
        file?.file?.originalname ||
        "Untitled file";

      return {
        rawFile: file,
        displayName: computedName,
        isMapped: false,
      };
    });
    setUploadedFiles((prev) => [...prev, ...normalized]);
    setShowUploadFileModal(false);
    setShowSalesUploadedFiles(true);
  };

  const handleStartMapping = (index) => {
    setSelectedFileIndex(index);
    setShowSalesUploadedFiles(false);
    setShowColumnMapping(true);
  };

  const handleResetMapping = (index) => {
    setUploadedFiles((prev) =>
      prev.map((item, idx) =>
        idx === index ? { ...item, isMapped: false } : item
      )
    );
  };

  const handleContinueMapping = () => {
    setShowColumnMapping(false);
    setShowSubMapping(true);
  };

  const handleSubmappingSuccess = () => {
    if (selectedFileIndex !== null) {
      setUploadedFiles((prev) =>
        prev.map((item, idx) =>
          idx === selectedFileIndex ? { ...item, isMapped: true } : item
        )
      );
    }
    setShowSubMapping(false);
    setShowSalesUploadedFiles(true);
  };

  const handleSubmitSubMapping = () => {
    setShowSubMapping(false);
    setShowSalesUploadedFiles(true);
  };

  const handleFinish = () => {
    const canFinish = uploadedFiles.some((file) => file.isMapped);
    if (!canFinish) {
      setErrorPopup({
        isOpen: true,
        title: "Mapping Required",
        message: "Please map at least one file before finishing.",
      });
      return;
    }
    setShowSalesUploadedFiles(false);
    setShowDataState(false);
    setTableType("excel");
    setShowTable(true);
    if (saleID) {
      sessionStorage.setItem(`tableType_${saleID}`, "excel");
    }
  };

  const handleSuccessERPModal = async () => {
    if (!selectedCardId) {
      setErrorPopup({
        isOpen: true,
        title: "Selection Required",
        message: "Please select an ERP package to proceed.",
      });
      return;
    }
    try {
      let resolvedSaleID = saleID;
      if (!resolvedSaleID) {
        const response = await GetSale();
        const sales =
          response.data?.sales ||
          response.data?.sale ||
          response.data?.result ||
          [];
        const saleArray = Array.isArray(sales) ? sales : [sales];
        if (saleArray.length > 0 && saleArray[0]) {
          resolvedSaleID =
            saleArray[0]._id || saleArray[0].id || saleArray[0].saleID;
        }
      }
      const selectedItem = (erpList || [])
        .flatMap((pkg, pkgIdx) => {
          if (Array.isArray(pkg.data) && pkg.data.length > 0) {
            return pkg.data.map((entry, entryIdx) => ({
              ...entry,
              _id: entry._id || `${pkg._id || pkgIdx}-${entryIdx}`,
              packageId: pkg._id || pkg.id,
            }));
          }
          return [pkg];
        })
        .find(
          (i) =>
            i._id === selectedCardId ||
            i.packageId === selectedCardId ||
            i.id === selectedCardId
        );

      const resolvedPackageId =
        selectedItem?.packageId || selectedItem?._id || selectedCardId;

      await putSaleFromERP(resolvedSaleID, resolvedPackageId);
      setShowERPModal(false);
      setSelectedCardId(null);
      setShowERPSuccessModal(true);
    } catch (error) {
      console.error("Failed to pull from ERP:", error);
      setErrorPopup({
        isOpen: true,
        title: "Error",
        message:
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          "Failed to pull ERP data. Please try again.",
      });
    }
  };

  const handleERPComplete = () => {
    setShowERPSuccessModal(false);
    setShowDataState(false);
    setTableType("erp");
    if (saleID) {
      sessionStorage.setItem(`tableType_${saleID}`, "erp");
    }
    setShowTable(false);
    setTimeout(() => {
      setShowTable(true);
    }, 0);
  };

  const handleAppendReplaceSelect = (action) => {
    setUploadAction(action);
    setShowAppendReplacePopup(false);
    setShowUploadExcelModal(true);
  };

  return (
    <>
      <div className={styles.header}>
        <div className={styles.rightSection}>
          <FilterIcon onClick={() => setShowFilter(true)} />

          <Datepicker
            date={asOnDate}
            onChange={(e) => setAsOnDate(e.target.value)}
            label="As on"
          />

          {/* {tableType === "erp" && (
            <SyncButton onClick={() => setShowPopup(true)} />
          )} */}
          {tableType === "erp" && (
            <AddregButton onClick={() => setShowAddRegisterModal(true)} />
          )}
          {tableType === "excel" && (
            <UploadButton onClick={() => setShowAppendReplacePopup(true)} />
          )}
          {tableType === null && (
            <AddregButton onClick={() => setShowAddRegisterModal(true)} />
          )}
        </div>
      </div>

      {showAddRegisterModal && (
        <AddSalesRegister
          onClose={() => setShowAddRegisterModal(false)}
          handleSelect={handleSelect}
        />
      )}

      {showUploadExcelModal && (
        <UploadExcelModal
          onClose={() => setShowUploadExcelModal(false)}
          onBack={() => {
            setShowUploadExcelModal(false);
            setShowAddRegisterModal(true);
          }}
          onSelectUploadType={handleSelectUploadType}
        />
      )}

      {showUploadFileModal && (
        <UploadFile
          SaleID={saleID}
          onClose={() => setShowUploadFileModal(false)}
          onBack={() => {
            setShowUploadFileModal(false);
            setShowUploadExcelModal(true);
          }}
          onProceed={handleProceedToSalesUploadedFiles}
        />
      )}

    
      {showSalesUploadedFiles && (
        <SalesUploadedFiles
          uploadedFiles={uploadedFiles}
          canFinish={uploadedFiles.some((file) => file.isMapped)}
          onBack={() => {
            setShowSalesUploadedFiles(false);
            setShowUploadFileModal(true);
          }}
          onStartMapping={handleStartMapping}
          onResetMapping={handleResetMapping}
          onFinish={handleFinish}
          onClose={() => setShowSalesUploadedFiles(false)}
          onRemove={handleRemoveFile}
          onAdd={handleAddFiles}
        />
      )}

      {showColumnMapping && (
        <ColumnMapping
          SaleID={saleID}
          onBack={() => {
            setShowColumnMapping(false);
            setShowSalesUploadedFiles(true);
          }}
          onContinue={handleContinueMapping}
          onClose={() => setShowColumnMapping(false)}
          onCancel={() => {
            setShowColumnMapping(false);
            setShowSalesUploadedFiles(true);
          }}
        />
      )}

      {showSubMapping && (
        <Submapping
          SaleID={saleID}
          onBack={() => {
            setShowSubMapping(false);
            setShowColumnMapping(true);
          }}
          onMapped={handleSubmappingSuccess}
          onSubmitMapping={handleSubmitSubMapping}
          onClose={() => setShowSubMapping(false)}
          onCancel={() => {
            setShowSubMapping(false);
            setShowSalesUploadedFiles(true);
          }}
        />
      )}

      {showERPModal && (
        <ERPModal
          erpList={erpList}
          selectedCardId={selectedCardId}
          setSelectedCardId={setSelectedCardId}
          isLoading={isErpLoading}
          onClose={() => {
            setShowERPModal(false);
            setSelectedCardId(null);
          }}
          onBack={() => {
            setShowERPModal(false);
            setSelectedCardId(null);
            setShowAddRegisterModal(true);
          }}
          onProceed={handleSuccessERPModal}
        />
      )}

      {showERPSuccessModal && <SyncERPSuccess onClose={handleERPComplete} />}

      {showFilter && (
        <CustomFilter
          onClose={() => setShowFilter(false)}
          onApply={handleApplyFilter}
          filterConfig={filterConfig}
          appliedFilters={appliedFilters}
        />
      )}

      {showPopup && <SyncPopup onClose={() => setShowPopup(false)} />}

      {showAppendReplacePopup && (
        <AppendReplaceFile
          onClose={() => setShowAppendReplacePopup(false)}
          onSelectUploadType={handleAppendReplaceSelect}
        />
      )}

      <SuccessPopup
        isOpen={successPopup.isOpen}
        title={successPopup.title}
        message={successPopup.message}
        onClose={() =>
          setSuccessPopup({ isOpen: false, title: "Success", message: "" })
        }
      />

      <ErrorPopup
        isOpen={errorPopup.isOpen}
        title={errorPopup.title}
        message={errorPopup.message}
        onClose={() =>
          setErrorPopup({ isOpen: false, title: "Error", message: "" })
        }
      />

      <DeletePopup
        isOpen={deletePopup.isOpen}
        title={deletePopup.title}
        message={deletePopup.message}
        onConfirm={handleConfirmDeleteFile}
        onCancel={() =>
          setDeletePopup({
            isOpen: false,
            title: "Are you sure?",
            message: "",
            fileIndex: null,
          })
        }
      />
    </>
  );
};

export default SalesregHeader;
